export const theme = {
    colors: {
        mainColor: '#3c39d0',
        subColor: '#f34141',
        latestColor: '#ffd360',
        backColor: '#e8e8e8',
        topColor: 'rgb(169, 28, 204)',
    },
    fontSizes: {
        extraLarge: '46px',
        large: '40px',
        medium: '34px',
        semi: '22px',
        small: '12px',
    },
};
